import React from "react";
import {
  copyToClipboard,
  formatDate,
  formatNumber,
  trimAddress,
} from "../helper/helper";
import { IoCopyOutline } from "react-icons/io5";
import { getNetwork } from "../helper/evmHelper";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { generateInvoicePdf } from "../helper/InvoicePdfGenerator";



const TransactionsDataTable = ({
  transactions,
  isCode = false,
  isAmount = false,
  isReceivedAmount = false,
  isStatus = true,
  isInvoice = false,
  isTaxAmount = false,
  isTxType = false,
  isAmountAfterTax = false,
}) => {
  const classOfTable = {
    cursor: "pointer",
  };

  console.log("transactions", transactions);

  const hasTransactionType = transactions?.some(t => t?.transactionType);

  return (
    <div className="table-box">
      <table className="table">
        <thead>
          <tr>
            <th>SN</th>
            <th>Chain Id</th>
            {hasTransactionType && <th>Payment Type</th>}
            {/* <th>Fiat Amount</th>
            <th>USD</th>
            <th>Fiat USD</th>
            <th>Coin ID</th> */}
            {isTxType && <th>Transaction Type</th>}
            <th>Transaction Hash</th>
            <th>From</th>
            <th>To</th>
            <th>Symbol</th>
            {isAmount && <th>Amount</th>}
            {isReceivedAmount && <th>Received</th>}
            {isTaxAmount && <th>Taxes</th>}
            {isAmountAfterTax && <th>Excluding Tax</th>}
            {isCode && <th>Code</th>}
            <th>Time Stamp</th>
            {isStatus && <th>Status</th>}
            {isInvoice && <th>Invoice</th>}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {transactions?.length > 0 ? (
            transactions.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data?.chainId}</td>
                {hasTransactionType && <td>{data?.transactionType || "--"}</td>}
                {/* <td>{data?.fiatAmount || "--"}</td>
                <td>{data?.cryptoToUsd || "--"}</td>
                <td>{data?.fiatToUsd || "--"}</td>
                <td>{data?.coinId || "--"}</td> */}
                {isTxType && <td>{data?.txType}</td>}
                <td>
                  <span
                    onClick={() => {
                      let explorerURL =
                        getNetwork(data?.chainId).explorerURL + data?.hash;
                      window.open(explorerURL ?? data?.linkURL);
                    }}
                    className="transaction-hash"
                  >
                    {trimAddress(data?.hash, 5, 8)}
                  </span>
                  {data?.hash ? (
                    <button
                      onClick={() => {
                        copy(data?.hash)
                        toast.success("Copied to clipboard!");
                      }}
                      style={{
                        marginLeft: "1rem",
                        border: "none",
                        background: "transparent",
                      }}
                    >
                      <IoCopyOutline />
                    </button>
                  ) : (
                    "--"
                  )}
                </td>

                <td>
                  {trimAddress(data?.fromAddress, 4, 5)}
                  {data?.fromAddress ? (
                    <button
                      onClick={() => {
                        copy(data?.fromAddress)
                        toast.success("Copied to clipboard!");

                      }}
                      style={{
                        marginLeft: "1rem",
                        border: "none",
                        background: "transparent",
                      }}
                    >
                      <IoCopyOutline />
                    </button>
                  ) : (
                    "--"
                  )}
                </td>
                <td>
                  {trimAddress(data?.toAddress ?? data?.to, 4, 5)}
                  <button
                    onClick={() => {
                      copy(data?.toAddress ?? data?.to)
                      toast.success("Copied to clipboard!");
                    }}
                    style={{
                      marginLeft: "1rem",
                      border: "none",
                      background: "transparent",
                    }}
                  >
                    <IoCopyOutline />
                  </button>
                </td>
                <td>{data?.symbol}</td>
                {isAmount && <td>{data?.amount}</td>}
                {isReceivedAmount && (
                  <td>{formatNumber(data?.recivedAmount ?? 0, 8)}</td>
                )}

                {isTaxAmount && <td>{formatNumber(data?.adminFee ?? 0, 8)}</td>}

                {isAmountAfterTax && (
                  <td>
                    {formatNumber(
                      data?.amountAfterTax ||
                      data?.amountAfterTax - data?.adminFee,
                      8
                    )}
                  </td>
                )}

                {isCode && <td>{data?.code} </td>}

                <td>{formatDate(data?.createdAt)}</td>

                {isStatus && (
                  <td>
                    <button
                      className={`status ${data?.status.toUpperCase() === "SUCCESS"
                        ? "success"
                        : data?.status.toUpperCase() === "EXPIRED"
                          ? "error"
                          : "pending"
                        }`}
                      onClick={() => {
                        let explorerURL =
                          getNetwork(data?.chainId).explorerURL + data?.hash;
                        window.open(data?.linkURL ?? explorerURL);
                      }}
                    >
                      {data?.status}
                    </button>
                  </td>
                )}

                {isInvoice && (
                  <td
                    onClick={async () => {
                      try {
                        await generateInvoicePdf(data);
                        toast.success("Invoice downloaded successfully!");
                      } catch (error) {
                        toast.error("Failed to generate invoice");
                        console.error("Invoice generation error:", error);
                      }
                    }}
                    className="table-invoice table-invoice-button"
                    style={{ cursor: "pointer" }}
                  >
                    {data?.invoice}
                    <i
                      className="ti ti-file-type-pdf"
                      style={{
                        fontSize: "24px",
                        marginRight: "10px",
                      }}
                    />
                  </td>
                )}

                <td>
                  <a href={`/transactions-view/${data?._id}`} style={{ cursor: "pointer" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#bfbfbf" // light gray outline
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: "20px",
                  }}
                >
                  <p>Data not found</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionsDataTable;
